import { render, staticRenderFns } from "./marksEntrySimple.vue?vue&type=template&id=3ca2ec0c&scoped=true&"
import script from "./marksEntrySimple.vue?vue&type=script&lang=js&"
export * from "./marksEntrySimple.vue?vue&type=script&lang=js&"
import style0 from "./marksEntrySimple.vue?vue&type=style&index=0&id=3ca2ec0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca2ec0c",
  null
  
)

export default component.exports